import { CircleGeometry, Mesh, MeshPhongMaterial, Object3D } from "three";

import { SceneObjectBase } from "../object";

export class StadiumGroundFallback extends SceneObjectBase {
  private ground = new Mesh(
    new CircleGeometry(1000, 32),
    new MeshPhongMaterial({ color: 0x567d46, shininess: 0 })
  );

  constructor() {
    super();

    this.ground.rotation.x = -Math.PI / 2;
  }

  get object(): Object3D {
    return this.ground;
  }
}
